import { section } from "@/glow";
import playButtonBlock from "@/lib/play-button-block";
import { animateScrollingTextBanner, shouldAnimate } from "@/lib/animation";

const selectors = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block",
};

section("scrolling-text-banner", {
  onLoad() {
    const playButtonVideos = Array.from(
      this.container.querySelectorAll(selectors.playButtonVideo)
    );

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(block =>
        playButtonBlock(block.closest(selectors.playButtonBlock))
      );
    }

    if (shouldAnimate(this.container)) {
      this.animateScrollingTextBanner = animateScrollingTextBanner(
        this.container
      );
    }
  },

  onUnload() {
    this.playButtons && this.playButtons.forEach(button => button.unload());
    this.animateScrollingTextBanner?.destroy();
  },
});
